import { Component } from '@angular/core';

@Component({
  selector: 'app-alert-save-modal',
  templateUrl: './alert-save-modal.component.html',
  styleUrls: ['./alert-save-modal.component.css']
})
export class AlertSaveModalComponent {

  constructor() { }


}
